import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


@Component({
  selector: 'app-swiper-slider',
  templateUrl: './swiper-slider.component.html',
  styleUrls: ['./swiper-slider.component.scss']
})
export class SwiperSliderComponent implements AfterViewInit, OnDestroy {

  swiper!: Swiper;
  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024;

  ngAfterViewInit(): void {
    this.swiper = new Swiper('.swiper-container.swiper-vip-user-reward', {
      modules: [Navigation, Pagination],
      breakpoints: {
        280: { slidesPerView: 1},
        480 : { slidesPerView: 2 },
        768: { slidesPerView: 3},
      },
      spaceBetween: 10,
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
      navigation: {
          nextEl: '.swiper-button-next-test',
          prevEl: '.swiper-button-prev-test',
      },
  });
  }


  ngOnDestroy(): void {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
